// components/common/FullPageLoader.tsx
const FullPageLoader = () => {
  return (
    <div className="flex items-center justify-center h-screen w-screen bg-primary">
      <img
        src="/assets/worklap-white-logo.svg"
        alt="Loading..."
        className="w-10 animate-spin"
        style={{ animationDuration: "1.5s" }}
      />
    </div>
  );
};

export default FullPageLoader;